const isInProd =
  !window.location.hostname.includes('develop') && !window.location.hostname.includes('localhost')

const STRIPE_KEY = isInProd
  ? 'pk_live_51JuD61Fy7Xww1SryZ9FIUwFxdwOOt6rVphdnKWXV9VJ92pAsC9S5KEoBD0Ckf6GB7HWeBr2szDcTueWjm4VojK0K003YvAM0SN'
  : 'pk_test_51JuD61Fy7Xww1Sry7eNtAFxVlD8uGblcaoYBhecSGccW76G6wRfo9Sb8hwFADGn9Yj8hxnomv2zdhkZFzJpSQUKl00faCbeNuG'

export default STRIPE_KEY
